var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconStaffBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_5994",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 5994",
    transform: "translate(-403 -165)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_2524",
    "data-name": "\\u9577\\u65B9\\u5F62 2524",
    width: 24,
    height: 24,
    transform: "translate(403 165)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(407.5 170.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_106_account_D",
    "data-name": "106_account_D",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11047",
    "data-name": "\\u30D1\\u30B9 11047",
    d: "M5.969,9.8a2.9,2.9,0,0,0,0-5.8A2.9,2.9,0,0,0,5.969,9.8Zm0-4.837a1.935,1.935,0,0,1,0,3.869A1.935,1.935,0,0,1,5.969,4.967Z",
    transform: "translate(-1.597 -2.021)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11048",
    "data-name": "\\u30D1\\u30B9 11048",
    d: "M19.969,5.8a2.9,2.9,0,0,0,0-5.8A2.9,2.9,0,0,0,19.969,5.8Zm0-4.837a1.935,1.935,0,0,1,0,3.869A1.935,1.935,0,0,1,19.969.967Z",
    transform: "translate(-9.339)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11049",
    "data-name": "\\u30D1\\u30B9 11049",
    d: "M7.758,19.62a3.983,3.983,0,0,0-.7-.7A4.383,4.383,0,0,0,.02,22.831H.987A3.413,3.413,0,0,1,6.81,20.007a3.575,3.575,0,0,1,.948,2.825h.967a4.561,4.561,0,0,0-.895-3.115c-.019-.034-.048-.063-.073-.1Z",
    transform: "translate(0 -9.831)",
    fill: "#377EF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_11050",
    "data-name": "\\u30D1\\u30B9 11050",
    d: "M19.147,14A4.337,4.337,0,0,0,15.5,15.983a1.643,1.643,0,0,1,.189.145,4.72,4.72,0,0,1,.542.5,3.414,3.414,0,0,1,6.3,2.21H23.5A4.408,4.408,0,0,0,19.147,14Z",
    transform: "translate(-8.516 -7.752)",
    fill: "#377EF3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStaffBlue);
export default __webpack_public_path__ + "static/media/icon_staff_blue.a3f7bc15b9346934579d4f5b5d1517d2.svg";
export { ForwardRef as ReactComponent };